var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"rounded-pill px-3 py-2 bg-light shadow-sm ml-2 mb-2",on:{"click":_vm.callBack}},[_vm._v(" "+_vm._s(_vm.locationData.displayName.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }